import React from 'react';
import { createUseStyles } from 'react-jss';

export default function FloatingInfo(props) {
  const { title, subtitle } = props;
  const c = useStyles(props);

  return (
    <div className={c.container}>
      <div className={c.titleContainer}>
        <div className={c.title}>{title}</div>
        <div className={c.subtitle}>{subtitle}</div>
      </div>
    </div>
  )
}

const useStyles = createUseStyles({
  container: {
    position: 'absolute',
    // Allow clicking the toolbar
    bottom: 30,
    width: 'fit-content',
    height: 'fit-content',
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    height: '100%',
    padding: '20px 18px'
  },
  title: {
    color: 'white',
    fontSize: '20px',
    marginBottom: 20,
  },
  subtitle: {
    color: 'rgba(201, 201, 209, 1)',
    fontSize: '14px',
  },
});
